module.exports = __webpack_public_path__ + "static/media/newsImage7.0e14fe38.svg";